export const processType = [
    {id:1, name:'CNC Machining'},
    {id:2, name:'3D Printing'},
    {id:3, name:'Sheet Metal Fabrication'},
    {id:4, name:'Injection Moulding/Casting'},
    {id:5, name:'Complete Assembly'},
    {id:6,name:'Vacuum casting'},
    {id:7,name:'Jigs and Fixtures'},
    {id:8, name:'Off-the-shelf parts (OEM)'},
    {id:9, name:'3D Printing'},
    {id:10,name: 'CNC Machining'},
    {id:11, name:'Other'}
]
